const { default: axiosInstance } = require("utils/axios");

const appendDataToFormData = (formData, data, parentKey = "") => {
  Object.entries(data).forEach(([key, value]) => {
    const fullKey = parentKey ? `${parentKey}[${key}]` : key;
    if (
      value instanceof File ||
      (Array.isArray(value) && value.every((item) => item instanceof File))
    ) {
      if (Array.isArray(value)) {
        value.forEach((file) => {
          formData.append(fullKey, file);
        });
      } else {
        formData.append(fullKey, value);
      }
    } else if (typeof value === "object" && value !== null) {
      appendDataToFormData(formData, value, fullKey);
    } else {
      formData.append(fullKey, value);
    }
  });
};

const createCustomerCar = async (data) => {
  console.log({ data });
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (key === "file") {
      if (Array.isArray(value)) {
        value.forEach((file) => {
          formData.append("file", file);
        });
      } else if (value) {
        formData.append("file", value);
      }
    } else {
      formData.append(key, value);
    }
  });
  try {
    const response = await axiosInstance.post(
      "/car-buy/createCustomer",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating customer car:", error);
    throw error;
  }
};

const createBuyCar = async (data) => {
  console.log({ data });
  const formData = new FormData();

  try {
    const response = await axiosInstance.post("/car-buy/createCar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating buy car:", error);
    throw error;
  }
};

const createOrderBuyCar = async (data) => {
  console.log({ data });
  const formData = new FormData();
  formData.append("customer_data", JSON.stringify(data.customer_data));
  formData.append("car_data", JSON.stringify(data.car_data));

  // if (data.image && data.image.length > 0) {
  //   data.image.forEach((file) => {
  //     formData.append("image", file);
  //   });
  // }
  
  // แนบรูปบัตรประชาชน (รองรับทั้ง DropZone และ WebSocket)
  if (data.image && data.image.length > 0) {
    for (const img of data.image) {
      if (img instanceof File) {
        // กรณีเป็นไฟล์จริง
        formData.append("image", img);
      } else if (img.file instanceof File) {
        // กรณีเป็น object { file: File, url, name }
        formData.append("image", img.file);
      } else if (img.url?.startsWith("data:image")) {
        // กรณีเป็น base64 (อ่านจากบัตร)
        const base64Response = await fetch(img.url);
        const blob = await base64Response.blob();
        const file = new File([blob], img.name || "customer_image.jpg", {
          type: blob.type,
        });
        formData.append("image", file);
      }
    }
  }
  if (data.car_photos && data.car_photos.length > 0) {
    data.car_photos.forEach((file) => {
      formData.append("car_photos", file);
    });
  }
  try {
    const response = await axiosInstance.post(
      "/car-buy/createCarOrder",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating order buy car:", error);
    throw error;
  }
};

const getCarBuyAllList = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-buy/get-all-car", {
      params: {
        ...filter,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching car buy list:", error);
    throw error;
  }
};

const getCarBuyById = async (id) => {
  try {
    const response = await axiosInstance.get(`/car-buy/get-car/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching car buy by ID:", error);
    throw error;
  }
};

const updateBuyCar = async (id, data) => {
  console.log({ id, data });
  const formData = new FormData();
  formData.append("car_data", JSON.stringify(data.car_data));

  if (data.car_photos && data.car_photos.length > 0) {
    data.car_photos.forEach((file) => {
      formData.append("car_photos", file);
    });
  }

  try {
    const response = await axiosInstance.put(
      `/car-buy/updateCar/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating buy car:", error);
    throw error;
  }
};
const deleteCarPictures = async (data) => {
  try {
    const response = await axiosInstance.delete(`/car-buy/deleteCarPics`, {
      data: {
        ids: data,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting car pictures:", error);
    throw error;
  }
};

const updateDocCarBuyStatus = async (car_id) => {
  try {
    const response = await axiosInstance.put(
      `/car-buy/update-doc-car-status/${car_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error updating document car buy status:", error);
    throw error;
  }
};

// documents
const createPowerOfAttorneyBuyCar = async (order_id, data) => {
  try {
    const response = await axiosInstance.post(
      `/car-buy/createCarPowerOfAttorney/${order_id}`,
      { ...data }, // ✅ ส่ง JSON ตรง ๆ
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating power of attorney:", error);
    throw error;
  }
};

const getPowerOfAttorneyBuyCarByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-power-of-attorney/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching power of attorney by ID:", error);
    throw error;
  }
};

const createTransferAndReceiptBuy = async (order_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));

    const response = await axiosInstance.post(
      `/car-buy/createCarTransformContact/${order_id}`,
      formData, // ✅ ส่ง JSON ตรง ๆ
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating transfer and receipt:", error);
    throw error;
  }
};

const getTransferAndReceiptBuyByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-transfer/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching transfer and receipt by ID:", error);
    throw error;
  }
};

const updatePowerOfAttorneyBuy = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("doc_data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-buy/update-power-of-attorney/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating power of attorney:", error);
    throw error;
  }
};

const updateTransformAndReceiptBuy = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("doc_data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-buy/update-car-transform/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating transfer and receipt:", error);
    throw error;
  }
};

const printPdfCarTransferBuy = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-transfer-pdf/${document_id}`,
      {
        responseType: "blob", // important
      }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF car transfer:", error);
    throw error;
  }
};

const printPdfPowerOfAttorneyBuy = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-power-of-attorney-pdf/${document_id}`,
      {
        responseType: "blob", // important
      }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF power of attorney:", error);
    throw error;
  }
};

const createBuyCarContract = async (order_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    const response = await axiosInstance.post(
      `/car-buy/createSellCarContract/${order_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating sell car contract document:", error);
    throw error;
  }
};

const getBuyCarContractByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-sell-contact/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sell car contract by ID:", error);
    throw error;
  }
};

const updateBuyCarContract = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-buy/update-car-sell-contact/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating sell car contract document:", error);
    throw error;
  }
};

const printPdfContractBuySell = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-buy/get-car-sell-contact-pdf/${document_id}`,
      {
        responseType: "blob", // important
      }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF sell car contract:", error);
    throw error;
  }
};

const BuyCarService = {
  createCustomerCar,
  createBuyCar,
  createOrderBuyCar,
  getCarBuyAllList,
  getCarBuyById,
  updateBuyCar,
  deleteCarPictures,
  updateDocCarBuyStatus,
  createPowerOfAttorneyBuyCar,
  createTransferAndReceiptBuy,
  getPowerOfAttorneyBuyCarByID,
  getTransferAndReceiptBuyByID,
  updatePowerOfAttorneyBuy,
  updateTransformAndReceiptBuy,
  printPdfCarTransferBuy,
  printPdfPowerOfAttorneyBuy,
  createBuyCarContract,
  getBuyCarContractByID,
  updateBuyCarContract,
  printPdfContractBuySell,
};

export default BuyCarService;
